/* eslint-disable*/

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import { AppSidebar } from 'components/Shell/AppSidebar/AppSidebar'
import SidebarMobile from '../../components/Sidebar/SidebarMobile'
import { SharedLayoutWrapper, DashboardContainer } from './SharedLayout.styled'
import useAuth from 'hooks/useAuth'
import { setLoadingAuth } from 'features/global/globalSlice'
import { RootState } from 'store'
import { permissionsAndLinks } from 'utils/helpers'

export const SharedLayout = () => {
  const { isAdmin, isInitialized } = useAuth()
  const { isSidebarOpen } = useSelector((store: RootState) => store.globals)
  const { user } = useSelector((state: RootState) => state.user)
  const dispatch = useDispatch()
  const navigate = useNavigate()


  useEffect(() => {
    if (isInitialized && location.pathname === '/') {
      dispatch(setLoadingAuth(true));
      if (isAdmin) {
        navigate('/resources-models');
      } else {
        const page = Object.keys(user?.currentContract?.role?.permissionPolicy || {}).filter(p => !['policyName', 'id', 'companyId'].includes(p)).find(o => user?.currentContract?.role.permissionPolicy[o]);
        navigate('/' + (page ? permissionsAndLinks[page] : 'dashboard'));
      }
    }
  }, [isAdmin, isInitialized]);

  let style = {}
  if (window.location.pathname === '/global-view') {
    style = {
      top: 0
    }
  }
  return (
    <SharedLayoutWrapper>
      {/* <HamburgerComponent sidebar={isSidebarOpen} /> */}
      <AppSidebar />
      <SidebarMobile />
      <DashboardContainer style={style} sidebar={isSidebarOpen}>
        <Outlet />
      </DashboardContainer>
    </SharedLayoutWrapper>
  )
}
